import styled, { css } from 'styled-components';

interface BadgeContainerProps {
  theme: Record<string, string>;
  color: string;
  size: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: { fontSize: '12px', iconSize: '13px' },
  medium: { fontSize: '14px', iconSize: '15px' },
  large: { fontSize: '16px', iconSize: '17px' },
};

export const BadgeContainer = styled.div<BadgeContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 2px solid;
  border-radius: 5px;
  padding: 0 2px 0 4px;
  ${({ size, color, theme }) => css`
    border-color: ${theme[color]};
    & span {
      font-size: ${sizeMap[size].fontSize};
    }
    background-color: ${theme[color]}88;
    color: ${theme.white};
    & svg {
      fill: ${theme.white};
      height: ${sizeMap[size].iconSize};
      width: ${sizeMap[size].iconSize};
      margin-right: 2px;
    }
  `}
  & span {
    font-family: 'Roboto', arial, sans-serif;
  }
`;

export const TooltipText = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', arial, sans-serif;
  & i {
    font-style: normal;
    font-size: 9px;
  }
`;
